import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=545cdf08&"
import script from "./MessageModal.vue?vue&type=script&lang=js&"
export * from "./MessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports